<template>
  <div class="page-headline">
    <div class="page-headline-contents">
      <FlowLineFourSteps
        class="page-headline-contents__flow-line"
        :steps="steps"
        :active-step="activeStep"
      />
      <PageHeadlineTitle class="page-headline-contents__title" :title="title" />
    </div>
  </div>
</template>
<script>
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle.vue'
import FlowLineFourSteps from '../../atoms/flow_lines/FlowLineFourSteps.vue'
export default {
  components: { PageHeadlineTitle, FlowLineFourSteps },
  props: {
    title: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      required: true,
      validator(value) {
        return value.length === 4
      }
    },
    activeStep: {
      type: Number,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  padding: 0 16px;
  background-color: $white;
  text-align: center;
  @media all and (max-width: $sp-width) {
    text-align: left;
  }
  &-contents {
    margin: auto;
    padding: 24px 0;
    max-width: $max-contents-width;
    @media all and (max-width: $base-contents-width) {
      max-width: $small-contents-width;
    }

    &__flow-line {
      padding-bottom: 24px;
    }

    &__title {
      margin: auto;
    }
  }
}
</style>
